/* Important Info component for the Character Edit page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../contexts/CurrentUserContext';

const InfoLatest = () => {
  const currentUser = useCurrentUser();
  return (
    <div className="mb-5">
        <Row className="mb-2">
        <Col md={{span: 8, offset: 2}}>
        <div className={`px-3 pt-1 pb-1 ${styles.SubTitle6 }`}>
        <h5 className={`text-center ${styles.Red }`} >INFO</h5>  
        <hr className={`mt-2 mb-0`}/>
        {currentUser &&
              currentUser?.groups.length > 0 &&
              (currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
        <p className={`pt-2 text-center`}>
          <span className={`${styles.Red}`}>*</span> Add or find all the current 
          Production <span className={`${styles.Red}`}>news, changes and information</span> here 
          in the Latest Buzz.
          </p>
                )}
        {currentUser &&
              currentUser?.groups.length > 0 &&
              (currentUser?.groups[0]?.name === "Crew") && (
        <p className={`pt-2 text-center`}>
          Find all the current Production <span className={`${styles.Red}`}>news, changes and information</span> here 
          in the Latest Buzz.
          </p>
                )}
          <hr />
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoLatest